<form
  [formGroup]="formGroup"
  class="gw-flex gw-min-w-0 gw-w-full gw-max-w-full gw-flex-col gw-gap-x-large"
  novalidate
>
  <div
    class="gw-grid gw-min-w-0 gw-grid-cols-1 lg:gw-grid-cols-2 gw-gap-x-medium gw-gap-y-x-large"
  >
    <gatewee-input-v2
      [form]="formGroup"
      controlName="name"
      [label]="'features.onboarding.leadForm.labels.fullName' | translate"
      type="text"
    ></gatewee-input-v2>
    <gatewee-input-v2
      [form]="formGroup"
      controlName="document"
      [label]="documentLabel"
      type="text"
      [mask]="documentMask"
    ></gatewee-input-v2>
  </div>

  <div
    class="gw-grid gw-min-w-0 gw-grid-cols-1 lg:gw-grid-cols-2 gw-gap-x-medium gw-gap-y-x-large"
  >
    <gatewee-input-v2
      [form]="formGroup"
      controlName="phone"
      [label]="'features.onboarding.leadForm.labels.phone' | translate"
      type="text"
      mask="(00)00000-0000"
    ></gatewee-input-v2>
    <gatewee-input-v2
      [form]="formGroup"
      controlName="email"
      [label]="'features.onboarding.leadForm.labels.email' | translate"
      type="email"
    ></gatewee-input-v2>
  </div>

  <div
    class="gw-rounded-lg gw-text-sm gw-flex gw-flex-col gw-gap-x-small gw-bg-background-neutral-1 gw-p-small"
    *ngIf="!allowNaturalPerson"
  >
    <p
      class="gw-mb-0 gw-flex gw-items-center gw-gap-x-small gw-text-text-secondary"
    >
      <gatewee-icon
        icon="@phi.info"
        iconStyle="primary"
        size="18px"
        class="gw-shrink-0"
      ></gatewee-icon>
      <span>{{
        'features.onboarding.leadForm.hints.needCnpj' | translate
      }}</span>
    </p>
    <p
      class="gw-mb-0 gw-flex gw-items-center gw-gap-x-small gw-text-text-secondary"
    >
      <gatewee-icon
        icon="@phi.info"
        iconStyle="primary"
        size="18px"
        class="gw-shrink-0"
      ></gatewee-icon>
      <span>{{
        'features.onboarding.leadForm.hints.mustBePartner' | translate
      }}</span>
    </p>
    <p
      class="gw-mb-0 gw-flex gw-items-center gw-gap-x-small gw-text-text-secondary"
    >
      <gatewee-icon
        icon="@phi.info"
        iconStyle="primary"
        size="18px"
        class="gw-shrink-0"
      ></gatewee-icon>
      <span>{{
        'features.onboarding.leadForm.hints.adminIfMultiple' | translate
      }}</span>
    </p>
  </div>

  <div class="gw-flex gw-flex-col gw-gap-x-small">
    <div class="gw-flex gw-items-start gw-gap-x-small">
      <gatewee-checkbox
        class="gw-shrink-0 gw-mt-0.5"
        formControlName="acceptTerms"
        inputId="lead-form-accept-terms"
        label=""
        size="s"
      ></gatewee-checkbox>
      <label
        for="lead-form-accept-terms"
        class="gw-min-w-0 gw-flex-1 gw-cursor-pointer gw-text-sm gw-text-text-secondary"
      >
        <span>{{
          'features.onboarding.leadForm.terms.prefix' | translate
        }}</span>
        <a
          [href]="privacyPolicy || 'javascript:void(0)'"
          class="gw-text-text-action hover:gw-underline"
        >
          {{ 'features.onboarding.leadForm.labels.privacyLink' | translate }}
        </a>
      </label>
    </div>
    <div
      class="gw-text-status-negative gw-text-sm gw-ms-[24px]"
      *ngIf="
        formGroup.get('acceptTerms')?.touched &&
        formGroup.get('acceptTerms')?.invalid
      "
    >
      {{ 'features.onboarding.leadForm.validation.acceptTerms' | translate }}
    </div>
  </div>
</form>
